export default {
    props: {
        scrollableDistance: {
            type: Number,
            kComposite: 'scrollable.distance'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/Common/Scrollable.js